exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".main .more-menu a[data-v-1e9d521e]{width:65px}", ""]);

